/**
* Configuracion del almacen de estados para el manejo de sesion a nivel de aplicacion 
*/

/**Definicion de componentes o librerias necesarias y que se complementan con el almacen de estados */
import Vue from 'vue'
import Vuex from 'vuex'
import HttpClientAxios from '@/gateway/axios'
import axios from 'axios'


/**Integramos el almacen de estados de Vuejs */
Vue.use(Vuex)

/**
 * Definimos el modulo propio para el manejo de estado de sesion
 */
export default {

    /**Atributo que permite definir espacios de modulo con el fin de registrar los captadores, acciones y mutaciones de forma automatica */
    namespaced: true,

    /**Objeto que permite definir el almacen de estados para el maejo de sesion */
    state: {

        /**Estado usuario con la informacion basica */
        user: {
            apellidos: '',
            user_name: '',
            id: '',
            nombres: '',
            perfil: '',
            puedeConsultarResultados: false
        },

        /**Estado de autenticacion */
        authentication: false,

        /**Estado para el manejo de permisos del usuario */
        permission: [],

        /**Estado para el manejo del avatar del usuario */
        avatar: ''
    },

    /**Objeto que permite manejar las mutaciones y alterar los estados del almacen */
    mutations: {

        /**Mutacion que permite modificar la informacion del usuario */
        SET_USER(state, user) {
            state.user = user
        },

        /**Mutacion que permite modificar el estado de autenticacion  */
        SET_UPDATE_AUTHENTICATION(state, authentication) {
            state.authentication = authentication;
        },

        /**Mutacion que pemrite cargar los permisos del usuario */
        SET_PERMISSION(state, permission) {
            state.permission = permission;
        },

        /**Mutacion que permite cargar el avatar del usuario */
        SET_AVATAR(state, avatar) {
            state.avatar = avatar;
        }
    },

    /**Objeto que permite definir las acciones del almacen */
    actions: {

        /**Metodo que permite autenticar el usuario y realizar los diferentes commit para alterar los estados con las mutaciones respectivas */
        async login({
            commit
        }, credentials) {
            const requestOptions = {
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                },
            }
            return HttpClientAxios.post(`${HttpClientAxios.defaults.formLoginUrl}/platform-security/v1/authorization/oauth/token`, credentials, requestOptions)
                .then(response => {
                    if (response.data.data.accessToken) {
                        localStorage.setItem('USER_TOKEN', response.data.data.accessToken);
                        let token = HttpClientAxios.defaults.JWT.decode();
                        commit('SET_USER', token.usuario);
                        commit('SET_UPDATE_AUTHENTICATION', true);
                        let url = '/msa-administracion/v1/usuarios/permisos';
                        return HttpClientAxios.get(url)
                    }
                }).then((response) => {
                    localStorage.setItem('SESSION', btoa(JSON.stringify(response.data.data)));
                    commit('SET_PERMISSION', response.data.data);
                    return true;
                })
                .catch(() => {
                    commit('SET_PERMISSION', []);
                    commit('SET_UPDATE_AUTHENTICATION', false);
                    return false
                })
        },

        /** Metodo que permite autenticar el usuario cuando ingresa desde el portal de famisanar */
        async loginPortal({
            commit
        }, credentials) {
            var requestLoginUser = {};
            requestLoginUser.identificacion = credentials.tipoDoc.concat("-").concat(credentials.identificacion);
            requestLoginUser.password = credentials.password;

            const requestOptions = {
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                },
            }
            return axios.post(`${HttpClientAxios.defaults.msaResultados}/msa-covid19-portal-muestras/v1/authentication/login`, requestLoginUser, requestOptions)
                .then(response => {
                    if (response.data) {
                        var usuarioResponse = {
                            apellidos: response.data.apellidos,
                            user_name: response.data.user_name,
                            id: response.data.id,
                            nombres: response.data.nombres,
                            perfiles: response.data.perfiles
                        };
                        commit('SET_USER', usuarioResponse);
                        localStorage.setItem('USER_TOKEN', response.data.token);
                        localStorage.setItem('USER', JSON.stringify(usuarioResponse));
                        commit('SET_UPDATE_AUTHENTICATION', true);
                        return true;
                    }
                }).catch(() => {
                    commit('SET_UPDATE_AUTHENTICATION', false);
                    return false
                })
        },

        /** Metodo que permite autenticar el usuario cuando ingresa desde el portal de famisanar con el hash */
        async loginPortalHash({
            commit
        }, credentials) {
            var requestLoginUser = credentials;

            const requestOptions = {
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                },
            }
            return axios.post(`${HttpClientAxios.defaults.msaResultados}/msa-covid19-portal-muestras/v1/authentication/login_hash`, requestLoginUser, requestOptions)
                .then(response => {
                    if (response.data) {
                        var usuarioResponse = {
                            apellidos: response.data.apellidos,
                            user_name: response.data.user_name,
                            id: response.data.id,
                            nombres: response.data.nombres,
                            perfiles: response.data.perfiles,
                        };

                        commit('SET_USER', usuarioResponse);
                        localStorage.setItem('USER_TOKEN', response.data.token);
                        localStorage.setItem('USER', JSON.stringify(usuarioResponse));
                        commit('SET_UPDATE_AUTHENTICATION', true);
                        return true;
                    }
                }).catch(() => {
                    commit('SET_UPDATE_AUTHENTICATION', false);
                    return false
                })
        },

        /**Metodo que pemrite cerrar la sesion del usuario */
        async logout({
            commit
        }) {
            commit('updateUser', null);
            commit('SET_UPDATE_AUTHENTICATION', false);
            localStorage.removeItem('USER_TOKEN');
            localStorage.removeItem('SESSION');
            localStorage.removeItem('USER');
        },

        /**Metodo que pemrite cargar los permisos del usuario autenticado */
        loadPermission({ commit }) {
            let session = localStorage.getItem('SESSION') ? atob(localStorage.getItem('SESSION')) : "";
            let permission = session === "" ? [] : JSON.parse(session);
            commit('SET_PERMISSION', permission);
        },

    },

    /**Objeto que permite definir metodos que se derivan de calculos en funcion del estado del almacen */
    getters: {

        /**Metodo que permite definir mensaje de bienvenida al usuario autenticado */
        greetings(state) {
            if (!state.user) {
                return null
            } else {
                return `Bienvenido ${state.user.nombres} ${state.user.apellidos}`;
            }
        },

        /**Metodo que permite verficar los permisos del usuario autenticado */
        hasRole: (state) => (rol) => {
            var regExp = new RegExp(`^${rol}`, 'g');
            return state.permission.find((authority) => regExp.test(authority));
        }
    }
}
